export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const ERROR_MSG_FIELD_REQUIRED = 'This field is required.'
export const ERROR_MSG_FIELD_MAX_LENGTH = 'Exceeds the maximum character length.'
export const ERROR_MSG_FIELD_FORMAT_INCORRECT = 'The field format is incorrect.'

export const PATTERN_NO_NUMERIC_STRING =
    /^[a-zA-ZÁÉÍÓÚÜáéíóúüäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛçÇñÑ]+(([',. -][a-zA-ZÁÉÍÓÚÜáéíóúüäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛçÇñÑ])?[a-zA-ZÁÉÍÓÚÜáéíóúüäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛçÇñÑ]*)*$/;
export const PATTERN_STRING = /^[a-zA-ZÁÉÍÓÚÜáéíóúüäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛçÇñÑ0-9_ "(),.-]*$/
export const PATTERN_POSTCODE = /^\d{5}$/;
export const PATTERN_CVV = /^(?!000)\d{3}$|^(?!0000)\d{4}$/;
export const PATTERN_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const PATTERN_PREFIX = /^[+]?(?:[0-9]?){2,3}$/
export const PATTERN_PHONE =
    /^(?:[ -]?(?:\(\d+(?:\.\d+)?\)|\d+(?:\.\d+)?))*(?:[ ]?(?:x|ext)\.?[ ]?\d{1,5})?$/
export const PATTERN_EXPIRED = /^(0[1-9]|1[0-2])\/[0-9]{2}$/
export const PATTERN_CREDIT_CARD =
    /^(?:4[0-9]{3}(?:\s*)[0-9]{4}(?:\s*)[0-9]{4}(?:\s*)[0-9]{1,4}?|5[1-5][0-9]{2}(?:\s*)[0-9]{4}(?:\s*)[0-9]{4}(?:\s*)[0-9]{4}|6(?:011|5[0-9][0-9])(?:\s*)[0-9]{4}(?:\s*)[0-9]{4}(?:\s*)[0-9]{4}|3[47][0-9]{2}(?:\s*)[0-9]{6}(?:\s*)[0-9]{5}|3(?:0[0-5]|[68][0-9])(?:\s*)[0-9]{4}(?:\s*)[0-9]{6}|(?:2131|1800|35\d{2})(?:\s*)\d{11})$/
export const PATTERN_PASSWORD =
    /^(?=.*[A-ZÁÉÍÓÚÜÄËÏÖÜÀÈÌÒÙÂÊÎÔÛÇÑ])(?=.*[a-záéíóúüäëïöüàèìòùâêîôûçñ])(?=.*[0-9!¡@#$%^&*.,+-/:;<>~?¿=|'ªº·_{}()])[A-Za-zÁÉÍÓÚÜáéíóúüäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛçÇñÑ0-9!¡@#$%^&*.,+-/:;<>~?¿=|'ªº·_{}()]{8,20}$/

export const REGEX_UPPER_LOWER_CASE =
    /^(?=.*[A-ZÁÉÍÓÚÜÄËÏÖÜÀÈÌÒÙÂÊÎÔÛÇÑ])(?=.*[a-záéíóúüäëïöüàèìòùâêîôûçñ]).*$/
export const REGEX_LENGTH = /^.{8,20}$/
export const REGEX_NUMBER_SYMBOL = /^(?=.*[0-9!¡@#$%^&*.,+-/:;<>~?¿=|'ªº·_{}()]).*$/

export const passwordPattern = {
    value: PATTERN_PASSWORD,
    message: 'The password is invalid',
}
export const emailPattern = {
    value: PATTERN_EMAIL,
    message: 'The email is incorrect',
}
export const stringPattern = (name: string) => ({
    value: PATTERN_STRING,
    message: `The ${name} is incorrect`,
})

export const noNumericStringPattern = (name: string) => ({
    value: PATTERN_NO_NUMERIC_STRING,
    message: `The ${name} is incorrect`,
})
